<template lang="pug">
nav.d-flex.flex-wrap.justify-end.main-header-nav-menu
  template(v-for="(route, i) in menu")
    v-btn.font-weight-bold(
      v-if="!route.dropdown && !route.getDropdown",
      :key="i",
      :to="route.path",
      color="white",
      text,
      small
    ) {{ route.name }}
    v-menu(v-else, :key="i", open-on-hover, bottom, offset-y)
      template(v-slot:activator="{ on, attrs }")
        v-btn.font-weight-bold(
          v-bind="attrs",
          v-on="on",
          :to="route.path",
          color="white",
          text,
          small
        ) {{ route.name }}
      v-list
        v-list-item(
          v-for="(r, i) in route.dropdown || []",
          :key="i",
          :to="r.path",
          exact
        )
          v-list-item-title {{ r.name }}
  v-btn.font-weight-bold.black--text(
    to="/sala-de-matriculas",
    color="secondary",
    depressed,
    small
  ) Sala de Matrículas
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
.main-header-nav-menu {
  gap: 16px;
}
</style>
